import { Command } from 'commands/Commands';

export abstract class ChangeColor extends Command {
  priority: number = 100;
  constructor(public payload: string, id = null) {
    super(payload);
  }
}
